/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseWorkingModeDiffData } from './genericApiResponseWorkingModeDiffData';
import type { GenericApiResponseWorkingModeDiffMessage } from './genericApiResponseWorkingModeDiffMessage';
import type { GenericApiResponseWorkingModeDiffPagination } from './genericApiResponseWorkingModeDiffPagination';
import type { GenericApiResponseWorkingModeDiffError } from './genericApiResponseWorkingModeDiffError';

export interface GenericApiResponseWorkingModeDiff {
  data?: GenericApiResponseWorkingModeDiffData;
  message?: GenericApiResponseWorkingModeDiffMessage;
  pagination?: GenericApiResponseWorkingModeDiffPagination;
  error?: GenericApiResponseWorkingModeDiffError;
  statusCode?: number;
}
